import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledImage = styled.img`
    display: block;
    height: auto;
    width: 170px;
`;

export const StyledImageWrapper = styled.div`
    min-height: 170px;
`;

export const StyledDescription = styled.p`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};
    margin: 0 0 8px;
    text-align: center;
`;

export const StyledInner = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    max-width: 300px;
    position: relative;
    top: -20px;
`;

export const StyledEmptyStateContainer = styled(CenteredFlexRow)`
    height: 100%;
`;
